import { render } from "./WelcomeImg3.vue?vue&type=template&id=5de96a2f"
import script from "./WelcomeImg3.vue?vue&type=script&lang=js"
export * from "./WelcomeImg3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__